<!-- 充值管理 -->
<template>
  <div class="content">
    <div class="bodycontent" v-loading="loading">
      <div class="option">
        <div class="left">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addCode()"
            size="small"
            >添加员工收款码</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="handleDownloadMulti()"
            size="small"
            >批量下载</el-button
          >
        </div>
        <div class="right">
          <span>
            <el-input
              type="text"
              placeholder=""
              v-model="keyword"
              style="width:200px"
              clearable
              size="small"
            />
          </span>
          <span>
            <el-button type="primary" @click="search()" size="small"
              >搜索</el-button
            >
          </span>
        </div>
      </div>
      <div class="dflex">
        <el-table
          :data="tableList"
          height="100%"
          border
          ref="multipleTable"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column label="名称" prop="name"></el-table-column> -->
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="员工编号" prop="emp.emp_no"></el-table-column>
          <el-table-column label="员工姓名" prop="emp.name"></el-table-column>
          <el-table-column label="油枪/类别" prop="show_name"></el-table-column>
          <el-table-column
            label="创建时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="startDownload(scope.row.id)"
                >下载收款码</el-button
              >
              <el-button type="text" @click="showItem(scope.row.id)"
                >收款记录</el-button
              >
              <el-button type="text" @click="editItem(scope.row.id)"
                >编辑</el-button
              >
              <el-button type="text" @click="delItem(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <el-dialog
        :visible.sync="showDetail"
        @close="showDetail = false"
        title="收款记录"
      >
        <el-table :data="detailList">
          <!-- <el-table-column label="员工"></el-table-column> -->
          <el-table-column
            label="支付方式"
            prop="show_payment"
          ></el-table-column>
          <el-table-column
            label="时间"
            prop="create_time"
            width="150px"
          ></el-table-column>
          <el-table-column label="金额">
            <template slot-scope="scope">
              <div>
                {{ scope.row.amount }}
                <el-button
                  type="text"
                  style="padding:0"
                  @click="MoneyDetail(scope.row)"
                  >详情</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="客户姓名"
            prop="user.real_name"
          ></el-table-column>
          <el-table-column label="电话" prop="user.mobile"></el-table-column>
        </el-table>
        <div style="margin-top:10px">
          <el-pagination
            layout="prev, pager, next, total, jumper"
            :current-page="detailPage"
            :total="detailTotal"
            :page-size="10"
            @current-change="changeDetailPage"
          >
          </el-pagination>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="showEdit"
        @close="showEdit = false"
        title="添加收款码"
        width="600px"
      >
        <div class="dialog_box">
          <el-form
            :model="formData"
            label-width="128px"
            v-loading="formLoading"
          >
            <el-form-item label="员工">
              <el-select v-model="formData.emp_id" size="small">
                <el-option
                  v-for="item in emp_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择对应设备">
              <el-radio-group v-model="formData.style" size="small">
                <el-radio label="1">油枪</el-radio>
                <el-radio label="2">类别</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="油枪信息" v-if="formData.style == '1'">
              <el-checkbox-group v-model="cateCheckList">
                <el-checkbox
                  v-for="item in equ_options"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="类别信息" v-if="formData.style == '2'">
              <el-checkbox-group v-model="typeCheckList">
                <el-checkbox
                  v-for="item in type_options"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="扫码注册会员级别">
              <el-select
                v-model="formData.level_id"
                placeholder="请选择"
                size="small"
              >
                <el-option-group
                  v-for="group in level_options"
                  :key="group.id"
                  :label="group.name"
                >
                  <el-option
                    v-for="item in group.lists"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="save" size="small"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="showEdit_edit"
        @close="showEdit_edit = false"
        title="添加收款码"
        width="600px"
      >
        <div class="dialog_box">
          <el-form
            :model="formData"
            label-width="128px"
            v-loading="formLoading"
          >
            <el-form-item label="员工">
              <el-select disabled v-model="formData.emp_id" size="small">
                <el-option
                  v-for="item in emp_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="请选择对应设备">
              <el-radio-group v-model="formData.style" size="small">
                <el-radio label="1">油枪</el-radio>
                <el-radio label="2">类别</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="油枪信息" v-if="formData.style == '1'">
              <el-checkbox-group v-model="cateCheckList">
                <el-checkbox
                  v-for="item in equ_options"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="类别信息" v-if="formData.style == '2'">
              <el-checkbox-group v-model="typeCheckList">
                <el-checkbox
                  v-for="item in type_options"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="扫码注册会员级别">
              <el-select
                disabled
                v-model="formData.level_id"
                placeholder="请选择"
                size="small"
              >
                <el-option-group
                  v-for="group in level_options"
                  :key="group.id"
                  :label="group.name"
                >
                  <el-option
                    v-for="item in group.lists"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="editsave" size="small"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <Judge
        :show="showJudge"
        :judgeText="judgeText"
        :judgeButton="judgeButton"
        @gotoNext="gotoNext()"
      ></Judge>
    </div>
    <!-- 收款详情 -->
    <el-dialog
      :visible.sync="showMoneyDetail"
      @close="showMoneyDetail = false"
      title="收款详情"
      width="300px"
    >
      <el-form :model="moneyDetailMsg" size="small" label-width="120px">
        <el-form-item label="原价">{{ moneyDetailMsg.money }}</el-form-item>
        <el-form-item label="会员优惠"
          >{{ moneyDetailMsg.dec_discount_money }}
        </el-form-item>
        <el-form-item label="优惠券优惠"
          >{{ moneyDetailMsg.dec_coupon_money }}
        </el-form-item>
        <el-form-item label="积分抵扣"
          >{{ moneyDetailMsg.dec_point_money }}
        </el-form-item>
        <el-form-item label="平台优惠">{{
          moneyDetailMsg.platform_discount || "0.00"
        }}</el-form-item>
        <el-form-item label="实际收款"
          >{{ moneyDetailMsg.amount }}
        </el-form-item>
        <el-form-item v-if="moneyDetailMsg.is_rounding" label="现金凑整">
          {{ moneyDetailMsg.numValue }}
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="showDownload"
      title="选择二维码下载"
      @close="closeDownload"
      width="400px"
    >
      <el-checkbox-group v-model="selectType">
        <el-checkbox
          v-for="item in qrcodeTypeList"
          :key="item.value"
          :label="item.value"
          class="check_type_item"
          >{{ item.name }}</el-checkbox
        >
      </el-checkbox-group>
      <div style="margin-top:30px">
        <el-button
          type="primary"
          style="width:100%"
          @click="downloadQrocde"
          :loading="downloading"
          >下载</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { delQrcode, getQrcode, qrcodeOrder } from "@/api/employee";
import {
  employeeOptions,
  equipmentOptions,
  getOilSortList,
  levelGroupSelect,
  qrcodeEdit,
  qrcodeInfo,
  qrcodeList
} from "@/api/vip";
import { mapGetters } from "vuex";
import Judge from "@/components/vip/judgeDialog";

export default {
  computed: {
    ...mapGetters(["token", "app_id", "status"])
  },
  components: {
    Judge
  },
  data() {
    return {
      showEdit_edit: false,
      tableList: [], //列表
      keyword: "",
      page: 1,
      total: 0,
      showDetail: false, //查看收款记录
      detailList: [], //收款记录 列表
      formData: {}, //添加表单
      showEdit: false, //编辑弹窗
      editForm: {}, //编辑表单
      loading: false, //页面loading
      qrcode: "", //普通二维码
      qrcode2: "", //关注二维码
      qrLoading: false, //获取二维码loading
      emp_options: [], //员工选择项
      equ_options: [], //油枪选择项
      type_options: [], //油品类别选项
      cateCheckList: [], //油枪选中的值
      typeCheckList: [], //油品类别选中的值
      formLoading: false, //表单loading
      showJudge: false, //判断没有员工
      judgeText: "您还没有添加员工，无法创建收款码",
      judgeButton: "去添加员工",
      detailPage: 1, //收款记录页码
      detailTotal: 0, //收款记录总数
      detailLoading: false, //收款记录loading
      showMoneyDetail: false, //收款记录金额详情
      moneyDetailMsg: {}, //收款记录金额详情
      showDownload: false, // 下载收款码弹窗
      selectType: [], // 选择下载的收款码类型
      qrcodeTypeList: [
        { name: "小程序通用码", value: "mini" },
        { name: "普通收款码", value: "h5" },
        { name: "关注收款码", value: "wx" },
        { name: "微信小程序码", value: "miniwx" },
        { name: "支付宝小程序码", value: "miniali" },
        { name: "普通订单收款码(无油品)", value: "normal" }
      ], // 收款码类型
      qrcode_id: "",
      downloading: false, // 下载loading
      multipleSelection: [], // 表格多选内容
      multiDownload: false, // 是否是多选
      level_options: [] // 会员等级选项
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      employeeOptions({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.emp_options = res.data;
          this.getData();
        } else if (res.code == 400) {
          this.showJudge = true;
          console.log("meiyouyuangong", this.showJudge);
        }
      });
      levelGroupSelect({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.level_options = res.data;
        } else {
        }
      });
    },
    async editItem(id) {
      this.youqiang();
      this.gettypeList();
      this.showEdit_edit = true;
      const res = await qrcodeInfo({ app_id: this.app_id, id: id });
      if (res.code == 200) {
        this.formData = res.data;
        this.formData.style = res.data.style.toString();
        this.cateCheckList = res.data.cate_id=='0'?[]:res.data.cate_id.split(",").map(Number);
        this.typeCheckList = res.data.type_id=='0'?[]:res.data.type_id.split(",").map(Number);
        this.formData.level_id = res.data.open_level;
      }
    },
    gotoNext() {
      this.$router.push("/apply/newVip/13/set/employee");
    },
    getData() {
      this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      };
      qrcodeList(data).then(res => {
        if (res.code == 200) {
          this.tableList = res.data;
          this.tableList.forEach(item => {
            var n = [];
            if (item.cate_id != "0") {
              //油枪
              item.cate.forEach(e => {
                n.push(e.name);
              });
            } else if (item.type_id != "0") {
              //类别
              item.types.forEach(e => {
                n.push(e.name);
              });
            }
            item.show_name = n.join(",");
          });
          this.total = res.total;
        } else {
          this.tableList = [];
        }
        this.loading = false;
      });
    },
    startDownload(id) {
      this.qrcode_id = id;
      this.showDownload = true;
    },
    // 关闭下载二维码弹窗
    closeDownload() {
      this.showDownload = false;
      this.qrcode_id = "";
      this.selectType = [];
      this.multiDownload = false;
    },
    // 下载二维码
    downloadQrocde() {
      if (this.selectType.length == 0) {
        this.$message.warning("请选择要下载的二维码类型");
      } else {
        this.downloading = true;
        setTimeout(() => {
          this.downloading = false;
          this.closeDownload();
        }, 3000);
        var type = this.selectType.join(",");
        console.log(type);
        var param =
          "?token=" +
          this.token +
          "&app_id=" +
          this.app_id +
          "&qrcode_id=" +
          this.qrcode_id +
          "&type=" +
          type;
        console.log("link params: ===================", param);
        if (this.selectType.length == 1 && !this.multiDownload) {
          var url1 =
            "https://www.58zltc.com/offlinestore/agent.down_qrcode/downloadone" +
            param;
          if (this.status == "test") {
            url1 =
              "https://cs.58zltc.com/offlinestore/agent.down_qrcode/downloadone" +
              param;
          }
          window.location.href = url1;
        } else {
          var url2 =
            "https://www.58zltc.com/offlinestore/agent.down_qrcode/download" +
            param;
          if (this.status == "test") {
            url2 =
              "https://cs.58zltc.com/offlinestore/agent.down_qrcode/download" +
              param;
          }
          window.location.href = url2;
        }
        this.$message.success("正在下载...");
      }
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //删除
    delItem(i) {
      console.log(i);
      var data = {
        token: this.token,
        app_id: this.app_id,
        qrcode_id: i
      };
      this.$confirm("删除后无法恢复，确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delQrcode(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getData();
            } else {
              this.$message(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //查看收款记录
    showItem(i) {
      this.detailLoading = true;
      this.qrcode_id = i;
      this.detailPage = 1;
      this.detailList = [];
      this.getQrcodeOrder();
    },
    //跳页
    changeDetailPage(p) {
      this.detailPage = p;
      this.getQrcodeOrder();
    },
    getQrcodeOrder() {
      this.showDetail = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        qrcode_id: this.qrcode_id,
        page: this.detailPage
      };
      qrcodeOrder(data).then(res => {
        if (res.code == 200) {
          this.detailList = res.data.data;
          this.detailTotal = res.data.total;
          this.detailList.forEach(item => {
            if (item.payment_code == "balance") {
              item.show_payment = "余额支付";
            } else if (item.payment_code == "unionpay") {
              item.show_payment = "银联支付";
            } else if (item.payment_code == "cash") {
              item.show_payment = "现金支付";
            } else if (item.payment_code == "card_balance") {
              item.show_payment = "加油卡支付";
            }
          });
        } else {
          this.$message(res.msg);
        }
      });
    },
    //新增
    addCode() {
      this.formData = {
        style: ""
      };
      this.cateCheckList = []
      this.typeCheckList = []
      console.log(this.formData)
      this.showEdit = true;
      if (this.emp_options.length == 0) {
        this.formLoading = true;
        employeeOptions({ token: this.token, app_id: this.app_id }).then(
          res => {
            if (res.code == 200) {
              this.emp_options = res.data;
            }
            this.formLoading = false;
          }
        );
      }
      if (this.equ_options.length == 0) {
        this.youqiang();
      }
      if (this.type_options.length == 0) {
        this.gettypeList();
      }
    },
    //油枪列表
    youqiang() {
      this.formLoading = true;
      equipmentOptions({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.equ_options = res.data;
        }
        this.formLoading = false;
      });
    },
    //类别列表
    gettypeList() {
      this.formLoading = true;
      getOilSortList(this.token, this.app_id).then(res => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.type_options = res.data;
          } else {
            this.$message("暂无油品类别数据...");
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //新增保存
    save() {
      console.log(this.formData);
      if (this.formData.emp_id == "") {
        this.$message({
          type: "error",
          message: "请选择员工"
        });
      } else if (this.formData.style == "") {
        this.$message({
          type: "error",
          message: "请选择类型"
        });
      } else {
        var data = Object.assign({}, this.formData);
        data.token = this.token;
        data.app_id = this.app_id;
        if (data.style == "1") {
          data.cate_id = this.cateCheckList.join(",");
        } else {
          data.type_id = this.typeCheckList.join(",");
        }
        console.log(data);
        this.formLoading = true;
        getQrcode(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "保存成功"
            });
            this.getData();
            this.showEdit = false;
            this.formLoading = false;
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    //编辑保存
    async editsave() {
      let arr = Object.keys(this.formData);
      arr.forEach(item => {
        switch (item) {
          case "id":
            break;
          case "style":
            break;
          case "cate_id":
            break;
          case "type_id":
            break;
          default:
            delete this.formData[item];
            break;
        }
      });
      if(this.cateCheckList.length>0){
        this.formData.cate_id = this.cateCheckList.join(',')
      }else {
        this.formData.cate_id = '0'
      }
      if(this.typeCheckList.length>0){
        this.formData.type_id = this.typeCheckList.join(',')
      }else {
        this.formData.type_id = '0'
      }
      this.formData.app_id = this.app_id;
      const res = await qrcodeEdit(this.formData);
      if (res.code == 200) {
        this.$message.success(res.msg);
        this.showEdit_edit = false
        this.formData = {}
        this.getData()
      } else {
        this.$message.error(res.msg);
      }
    },
    // 收款详情
    MoneyDetail(data) {
      this.moneyDetailMsg = {
        money: data.money,
        dec_discount_money: data.dec_discount_money,
        dec_coupon_money: data.dec_coupon_money,
        dec_point_money: data.dec_point_money,
        amount: data.amount,
        platform_discount: data.platform_discount
      };
      let numValue =
        Number(data.money) -
        Number(data.dec_discount_money) -
        Number(data.dec_coupon_money) -
        Number(data.pay_discount) -
        Number(data.dec_point_money) -
        Number(data.amount);
      console.log("优惠金额", numValue);
      this.moneyDetailMsg.is_rounding = true;
      // if (numValue == 0) {
      //   this.moneyDetailMsg.is_rounding = false;
      // } else if (numValue > 0) {
      //   this.moneyDetailMsg.roundTitle = "现金多收凑整";
      // } else if (numValue < 0) {
      //   this.moneyDetailMsg.roundTitle = "现金优惠凑整：";
      // }
      if (numValue == 0) {
        this.moneyDetailMsg.is_rounding = false;
      }
      this.moneyDetailMsg.numValue = numValue.toFixed(2);
      this.showMoneyDetail = true;
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 多选下载
    handleDownloadMulti() {
      if (this.multipleSelection.length == 0) {
        this.$message("请选择二维码");
      } else {
        this.qrcode_id = this.multipleSelection.map(x => x.id).join(",");
        this.multiDownload = true;
        this.showDownload = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    background: #fff;
    height: 100%;
    padding: 10px 15px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    .option {
      height: 60px;
      line-height: 60px;
      display: flex;
      .left {
        flex: 1;
      }
      .right {
        text-align: right;
        span {
          margin-left: 30px;
          .el-select {
            width: 150px;
          }
        }
      }
    }
    // table
    .el-table {
      flex: 1;
      box-shadow: 0 0 3px #f1f1f1;
      padding-left: 10px;
    }
    .discount_box {
      flex: 1;
      .discount_item {
        height: 40px;
        line-height: 40px;
        span {
          margin-left: 20px;
        }
      }
    }
    .level_img {
      width: 60px;
      height: 60px;
    }
    .dflex {
      flex: 1;
      .qr_img {
        width: 220px;
        height: 220px;
      }
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
    .dialog_box {
      margin: 0 50px;
      .bottom {
        text-align: center;
        margin-top: 30px;
      }
    }
  }
  .check_type_item {
    display: block;
    margin-bottom: 15px;
    font-size: 18px;
  }
}
</style>
